import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

interface HookProps {
  noPadding?: boolean;
}

export default makeStyles<Theme, HookProps>(
  theme =>
    createStyles({
      root: {
        display: 'flex',
        flexDirection: 'column',
        padding: props => (props.noPadding ? 0 : undefined),
      },
      header: {
        minHeight: '48px',
        boxSizing: 'border-box',
        padding: props => (props.noPadding ? 8 : 0),
        '& .MuiCardHeader-avatar': {
          display: 'flex',
          alignItems: 'center',
          marginRight: 8,
          color: theme.palette.primary.main,
        },
        '& .MuiCardHeader-title': {
          fontWeight: 300,
          color: '#595959',
        }
      },
    }),
  { name: 'AssembleiaCard' }
);
